import CoverageMap from './CoverageMap';

export default CoverageMap;
